import { useRecoilState } from 'recoil'
import {
    newFormIdAtom,
    newFormServiceTypeAtom,
} from '../../../../../State/Atoms/FormProps/FormPropsAtoms'
import {
    assetTypesAtom,
    assetCategoriesAtom,
    newFormAssetTypeAtom,
    assetServiceTypesAtom,
    newFormCategoryAtom,
} from '../../../../../State/Atoms/AssetData/AssetDataAtoms'
import { DropDownList } from '../../../../../../GlobalComponents/awc-reactjs-components'
import { handleChooseAsset } from '../../Handlers/handleChooseAsset'

export const AssetTypeDropdown = () => {
    const [assetTypes,setAssetTypes] = useRecoilState(assetTypesAtom)
    const [newFormId, setNewFormId] = useRecoilState(newFormIdAtom)
    const [newFormServiceType, setNewFormServiceType] = useRecoilState(newFormServiceTypeAtom)
    const [newFormAssetType, setNewFormAssetType] = useRecoilState(newFormAssetTypeAtom)
    const [assetServiceTypes, setAssetServiceTypes] = useRecoilState(assetServiceTypesAtom)
    const [newFormCategory, setNewFormCategory] = useRecoilState(newFormCategoryAtom)
    console.log('assetTypes ')
    console.log(assetTypes)
    const assetTypesSorted = assetTypes
        ? [...assetTypes].sort((a, b) => (a.OrderBy < b.OrderBy ? -1 : 1))
        : []
    return (
        assetTypes && (
            <div>
                <h3>Choose Asset Type</h3>
                <div style={{ paddingTop: '21px', paddingBottom: '20px' }}>
                    <DropDownList
                        // name={props.name || ''}
                        key='ddlChooseAssetType'
                        id='ddlChooseAssetType'
                        className='form-control form-control-sm'
                        onChange={(e) =>
                            handleChooseAsset(
                                e,
                                'assetType',
                                setNewFormId,
                                setNewFormServiceType,
                                setAssetServiceTypes,
                                setNewFormAssetType,
                                setNewFormCategory,
                                setAssetTypes
                            )
                        }
                        options={[
                            {
                                ID: '',
                                Name: '-- Select One --',
                            },
                            ...assetTypesSorted,
                        ].map((curAssetType) => (
                            <option
                                key={`assetTypeOp${curAssetType.ID}`}
                                value={curAssetType.ID}
                            >{`${curAssetType.Name.trim()}`}</option>
                        ))}
                    />
                </div>
            </div>
        )
    )
}

